'use strict';

import defaultMetadataFetch from './api/default-metadata-fetch';

const _basePath = '//www.svtstatic.se/video';

const config = {
    basePath: _basePath,
    nojsPlayerBaseUrl: 'https://api.svt.se/videoplayer-embed/nojs/',
    defaultThumbnail:
        'https://www.svtplay.se/public/images/default/play_default_998x561.jpg',
    cssPath: 'css',
    jsPath: 'js',
    imgPath: 'img',
    swfPath: 'swf',
    plugins: [
        'android-fallback',
        'ui',
        'windows-phone-fallback',
        'chromecast',
        'splash',
        'captions',
        'error-handler',
        'keyboard-navigation',
        'akamai-stats',
        'mms-stats',
        'thumbnails',
        'embed',
        'airplay',
        'pictureinpicture',
        'metrics',
        'linkpulse',
        'svt-data'
    ],
    flashEngine: null,
    resetOnEnd: true,
    splash: true,
    theme: 'standard',
    useAltDashUrl: false,
    useAltHlsUrl: false,
    chromecast: {
        receiverApplicationId: '95370A1C',
        buttonContainer: 'top-right' // Allowed values: top-right, controls
    },
    isInNativeApp: false,
    metadataFetchFunction: defaultMetadataFetch,
    androidFallback: null,
    sentry: {
        dsn: 'https://628a611dab944712ba98fb9c6fde80b1@sentry.io/232503',
        sampleRate: 1.0,
        ignoreErrors: []
    },
    svtDataSdkClient: null,
    breakPoints: [
        {
            'svp_container--lower-small': 'only screen and (max-width: 340px)'
        },
        {
            'svp_container--small': 'only screen and (max-width: 480px)!default' //default
        },
        {
            'svp_container--upper-small':
                'only screen and (min-width: 341px) and (max-width: 480px)'
        },
        {
            'svp_container--lower-medium':
                'only screen and (min-width: 481px) and (max-width: 620px)'
        },
        {
            'svp_container--medium':
                'only screen and (min-width: 481px) and (max-width: 800px)'
        },
        {
            'svp_container--upper-medium':
                'only screen and (min-width: 621px) and (max-width: 800px)'
        },
        {
            'svp_container--large': 'only screen and (min-width:801px)'
        },
        {
            'svp_container--upper-large': 'only screen and (min-width:1024px)'
        }
    ],
    messages: {
        error: {
            defaultError: {
                text: 'Problem med uppspelningen',
                link: {
                    text: 'Få hjälp med uppspelningen',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            loadError: {
                text: 'Kunde inte starta uppspelningen',
                retry: true,
                link: {
                    text: 'Få hjälp med uppspelningen',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            mediaErrorAborted: {
                text: 'Uppspelningen avbröts',
                link: {
                    text: 'Få hjälp med uppspelningen',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            mediaErrorNetwork: {
                text: 'Problem med internetanslutningen',
                retry: true,
                link: {
                    text: 'Få hjälp med uppspelningen',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            mediaErrorDecode: {
                text: 'Tekniskt fel på videofilen'
            },
            mediaErrorSrcNotSupported: {
                text: 'Enheten kan inte spela programmet',
                link: {
                    text: 'Få hjälp med uppspelningen',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            loadPlayerError: {
                text: 'Problem med uppspelningen',
                retry: true,
                link: {
                    text: 'Få hjälp med uppspelningen',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            unknownVideoTypeError: {
                text: 'Kan inte spela programmet',
                link: {
                    text: 'Få hjälp med uppspelningen',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            flashNotSupported: {
                text: 'Du behöver aktivera eller ladda ned Flash',
                link: {
                    text: 'För att titta behöver du Flash',
                    url:
                        'https://kontakt.svt.se/guide/installera-eller-uppdatera-flash'
                }
            },
            geoblockError: {
                text: 'Programmet kan bara ses i Sverige',
                link: {
                    text: 'Mer information om rättigheter utomlands',
                    url:
                        'https://kontakt.svt.se/guide/anvand-svt-play-utomlands'
                }
            },
            rightsExpiredError: {
                text: 'Programmet finns inte kvar',
                link: {
                    text: 'Mer information om rättigheter',
                    url: 'https://kontakt.svt.se/guide/rattigheter'
                }
            },
            liveNotStartedError: {
                text: 'Sändningen har inte startat än'
            },
            programNotStartedError: {
                text: 'Programmet går inte att titta på än'
            },
            drmProtectionError: {
                text: 'Programmet kan inte visas på denna enhet',
                link: {
                    text: 'Information om rättighetsskyddat material',
                    url: 'https://kontakt.svt.se/guide/kopieringsskydd'
                }
            },
            immersiveNotSupported: {
                text: 'Din webbläsare kan inte spela upp 360-video',
                link: {
                    text: 'Få hjälp med 360-video',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            immersiveFailedToLoad: {
                text: 'Problem med uppspelning av 360-video',
                link: {
                    text: 'Få hjälp med 360-video',
                    url: 'https://kontakt.svt.se/guide/uppspelningsproblem'
                }
            },
            flashDeprecation: {
                text:
                    'Dags att byta webbläsare\n\nSnart går det inte att titta på SVT Play med Internet Explorer ihop med Windows 7.\nVi rekommenderar därför att du byter webbläsare till Chrome eller Firefox.',
                link: {
                    text: 'Läs mer',
                    url:
                        'https://kontakt.svt.se/guide/installerauppdatera-webblasare'
                }
            }
        },
        general: {
            retry: 'Försök igen'
        }
    }
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/js/config.js